import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import IntlCurrencyInput from "react-intl-currency-input"
class InputCustom extends Component {
  getConfig() {
    return {
      locale: "pt-BR",
      formats: {
        number: {
          BRL: {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 3,
            maximumFractionDigits: 3
          }
        }
      }
    }
  }
  render() {
    return (
      <div className={this.props.sizeClass}>
        <div className="form-group label-floating">
          <label className="control-label">{this.props.label}</label>
          <IntlCurrencyInput

            defaultValue={this.props.defaultValue}
            currency="BRL"
            config={this.getConfig()}
            onKeyDown={this.props.onKeyDown}
            onChange={this.props.onChange}
            value={this.props.value}
            className="form-control"
            disabled={this.props.disabled}
          />
          <span className="label label-danger">{this.props.error}</span>
        </div>
      </div>
    )
  }
}
export default withRouter(InputCustom)



// WEBPACK FOOTER //
// ./src/components/InputCurrency.js